// extracted by mini-css-extract-plugin
export default {"ongoing-registrations":"bJzHTKOZZ9pIa9O7lJzY2g==","ongoing-registrations-selectors":"IvJLO-i1rDjVHU2w5naSew==","continue-new-registration-cta":"_02I9rqFwl5YobFf2EgmGGA=="};